export function toHex(rgb) { 
  var hex = Number(rgb).toString(16);
  if (hex.length < 2) {
    hex = '0' + hex;
  }
  return hex;
};

export function parseRgb(color) {
  if (typeof color === 'string' && color.toLowerCase().indexOf('rgb') > -1) {
    const colors = color.toLowerCase().replace('rgba(', '').replace('rgb(', '').replace(')').split(',').map(function (c) {
      const val = parseInt(c.trim(' '), 10);
      if (isNaN(val)) {
        return 0;
      } else {
        return Math.max(0, Math.min(255, val));
      }
    });
    if (colors.length > 2) {
      return `#${toHex(colors[0])}${toHex(colors[1])}${toHex(colors[2])}`;
    };
  }
  return color;
};


export function isWhite(color) {
  if (color) {
    const hex = parseRgb(color);
    const HEX = hex && typeof hex === 'string' && hex.toLowerCase();
    if (HEX && HEX === '#ffffff' || HEX === '#fff' || HEX === 'white') {
      return true;
    }    
  }
  return false;
};

export function adjustWhiteColor(color) {
  if (isWhite(color)) {
    return 'white';
  }
  return color;
}

export default {
  isWhite,
  adjustWhiteColor
};

export const PERCENTILE_LINE_COLORS = {
  30: '#359eb1',
  50: '#4379c1',
  70: '#b68d2c',
  85: '#da7940',
  95: '#cb5264',
  98: '#ab3855'
};

export const PERCENTILE_LABEL_COLORS = {
  30: '#2b8090',
  50: '#3f76c0',
  70: '#917023',
  85: '#b95b24',
  95: '#c94a5d',
  98: '#ab3855'
};
